import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontRoboto } from "shared/lib/styles";

type ContainerProps = {
  $isExpand: boolean;
};
export const Container = styled.div<ContainerProps>`
  position: relative;

  color: #4585ff;
  font-size: 16px;
  font-family: ${fontRoboto};
  line-height: 20.8px;

  cursor: pointer;
  &:after {
    position: absolute;
    content: "";

    margin-block-start: 7px;
    margin-inline-start: 7px;

    border-inline-end: 8px solid transparent;
    border-block-end: 8px solid #4585ff;
    border-inline-start: 8px solid transparent;

    transform: rotate(180deg);
    ${props => {
      if (!props.$isExpand) return;
      return css`
        margin-block-start: 5px;

        transform: rotate(0deg);
      `;
    }}
  }
`;
